// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__EvdhC","title":"FrontImage_title__1LaHe"};